import Typewriter from 'typewriter-effect/dist/core';

document.addEventListener('DOMContentLoaded', ()=> {

    const init = ()=> {
        window.typewriter = new Typewriter(document.querySelector('#typewriter'), {
            delay: 40,
            deleteSpeed: 10,
            loop: true,
            strings: ['big tech, ​software<br /> house ​or startup?', 'Telco czy IT?', 'team polski czy <br />między<span class="break">-</span>narodowy?', 'home <br />czy office?'],
            autoStart: true
        });
    }
          
    document.querySelector('#typewriter') ? init() : false;

}, false);
